var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlungerLift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 441.377H852.393L851.202 547.614L755.636 504.578L646.19 552.731L558.95 511.5L452.677 577.409L321.817 611.116L238.147 562.963L203.648 520.227L122.356 555.439L102.133 511.5L26.79 492.539L2.99902 441.377Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99902 441.377H852.393L851.202 547.614L755.636 504.578L646.19 552.731L558.95 511.5L452.677 577.409L321.817 611.116L238.147 562.963L203.648 520.227L122.356 555.439L102.133 511.5L26.79 492.539L2.99902 441.377Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M227.264 554.636H177.706V667.995H227.264V554.636Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 526.567V668.916H228.191L228.4 514.384",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 526.567V668.916H228.191L228.4 514.384",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 526.567V668.916H228.191L228.4 514.384",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M176.707 526.567V668.916H228.191L228.4 514.384",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.879 528.654L237.094 512.797",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.879 528.654L237.094 512.797",
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 663.184L131.961 659.973L176.903 657.365",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 663.184L131.961 659.973L176.903 657.365",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 663.184L131.961 659.973L176.903 657.365",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 663.184L131.961 659.973L176.903 657.365",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 647.984L131.76 645.375L176.903 642.165",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 647.984L131.76 645.375L176.903 642.165",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 647.984L131.76 645.375L176.903 642.165",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M177.104 647.984L131.76 645.375L176.903 642.165",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 641.211L271.804 644.823L227.84 648.234",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 641.211L271.804 644.823L227.84 648.234",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 641.211L271.804 644.823L227.84 648.234",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M227.866 641.211L271.804 644.823L227.84 648.234",
    stroke: "black",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 656.715L271.908 661.129L227.994 663.939",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 656.715L271.908 661.129L227.994 663.939",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 656.715L271.908 661.129L227.994 663.939",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M228.169 656.715L271.908 661.129L227.994 663.939",
    stroke: "black",
    strokeWidth: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 519.274V439.822H227.012V508.221",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 519.274V439.822H227.012V508.221",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 519.274V439.822H227.012V508.221",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M176.602 519.274V439.822H227.012V508.221",
    stroke: "black",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M176.823 440.619L176.749 455.622L226.631 447.572V440.468L176.823 440.619Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M176.823 440.619L176.749 455.622L226.631 447.572V440.468L176.823 440.619Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 469.014V454.869L218.435 449.377V463.748L185.405 469.014Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 469.014V454.869L218.435 449.377V463.748L185.405 469.014Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M218.435 463.246V509.995",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M218.435 463.246V509.995",
    stroke: "black",
    strokeWidth: 2
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M509.158 385.258H77.3879V398.992H509.158V385.258Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M509.158 385.258H77.3879V398.992H509.158V385.258Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M233.257 124.102H173.066V128.917H233.257V124.102Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M233.257 124.102H173.066V128.917H233.257V124.102Z",
    fill: "white",
    stroke: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.714 72.8511H198.685V279.413H207.714V72.8511Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M207.714 72.8511H198.685V279.413H207.714V72.8511Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 277.757H194.961V328.919H211.514V277.757Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 277.757H194.961V328.919H211.514V277.757Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M221.897 327.114H185.18V346.676H221.897V327.114Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M221.897 327.114H185.18V346.676H221.897V327.114Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M235.891 425.927H167.875V434.956H235.891V425.927Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M235.891 425.927H167.875V434.956H235.891V425.927Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M239.352 433.201H164.113V441.327H239.352V433.201Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M239.352 433.201H164.113V441.327H239.352V433.201Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M229.721 370.601H176.753V425.826H229.721V370.601Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M229.721 370.601H176.753V425.826H229.721V370.601Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 375.316H168.928V378.476H174.345V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 375.316H168.928V378.476H174.345V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 375.316H176.753V378.476H182.17V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 375.316H176.753V378.476H182.17V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 375.316H184.578V378.476H189.995V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 375.316H184.578V378.476H189.995V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 375.316H192.403V378.476H197.82V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 375.316H192.403V378.476H197.82V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 375.316H200.227V378.476H205.644V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 375.316H200.227V378.476H205.644V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 375.316H208.052V378.476H213.469V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 375.316H208.052V378.476H213.469V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 375.316H215.877V378.476H221.294V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 375.316H215.877V378.476H221.294V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 375.316H223.702V378.476H229.119V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 375.316H223.702V378.476H229.119V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 375.316H231.527V378.476H236.944V375.316Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 375.316H231.527V378.476H236.944V375.316Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M241.91 343.766H164.113V375.718H241.91V343.766Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M241.91 343.766H164.113V375.718H241.91V343.766Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 340.857H168.928V344.017H174.345V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M174.345 340.857H168.928V344.017H174.345V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 340.857H176.753V344.017H182.17V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M182.17 340.857H176.753V344.017H182.17V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 340.857H184.578V344.017H189.995V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M189.995 340.857H184.578V344.017H189.995V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 340.857H192.403V344.017H197.82V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M197.82 340.857H192.403V344.017H197.82V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 340.857H200.227V344.017H205.644V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M205.644 340.857H200.227V344.017H205.644V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 340.857H208.052V344.017H213.469V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M213.469 340.857H208.052V344.017H213.469V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 340.857H215.877V344.017H221.294V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M221.294 340.857H215.877V344.017H221.294V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 340.857H223.702V344.017H229.119V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M229.119 340.857H223.702V344.017H229.119V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 340.857H231.527V344.017H236.944V340.857Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M236.944 340.857H231.527V344.017H236.944V340.857Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M202.71 370.753C204.746 370.753 206.397 369.102 206.397 367.066C206.397 365.03 204.746 363.379 202.71 363.379C200.674 363.379 199.023 365.03 199.023 367.066C199.023 369.102 200.674 370.753 202.71 370.753Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M164.113 359.467H241.91",
    stroke: "black",
    strokeWidth: 2
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M755.565 242.997L771.215 230.582L218.536 230.407L218.435 243.247L755.565 242.997Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M755.565 242.997L771.215 230.582L218.536 230.407L218.435 243.247L755.565 242.997Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M450.246 228.325H436.778V246.232H450.246V228.325Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M450.246 228.325H436.778V246.232H450.246V228.325Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M446.333 224.262H440.841V249.617H446.333V224.262Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M446.333 224.262H440.841V249.617H446.333V224.262Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M531.429 228.325H498.399V246.232H531.429V228.325Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M531.429 228.325H498.399V246.232H531.429V228.325Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 220.375H194.961V254.182H211.514V220.375Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M211.514 220.375H194.961V254.182H211.514V220.375Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M211.614 229.053L207.751 236.376L211.614 244.451L219.438 244.602L219.588 229.102L211.614 229.053Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M211.614 229.053L207.751 236.376L211.614 244.451L219.438 244.602L219.588 229.102L211.614 229.053Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M152.903 382.85H107.985V401.751H152.903V382.85Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M152.903 382.85H107.985V401.751H152.903V382.85Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M289.235 382.85H244.317V401.751H289.235V382.85Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M289.235 382.85H244.317V401.751H289.235V382.85Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M168.627 520.969L236.041 505.52",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M168.627 520.969L236.041 505.52",
    stroke: "black",
    strokeWidth: 2
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M467.986 382.328H440.148V401.229H467.986V382.328Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M467.986 382.328H440.148V401.229H467.986V382.328Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M459.109 380.623H449.177V402.935H459.109V380.623Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M459.109 380.623H449.177V402.935H459.109V380.623Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M533.547 328.8C535.521 355.799 523.312 389.102 512.779 397.317L511.575 398.521C498.111 415.063 475.072 408.591 459.45 400.512",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M533.547 328.8C535.521 355.799 523.312 389.102 512.779 397.317L511.575 398.521C498.111 415.063 475.072 408.591 459.45 400.512",
    stroke: "black",
    strokeWidth: 2
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M296.555 197.976C296.485 202.669 299.327 229.05 337.648 230.477L296.555 197.976Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M296.555 197.976C296.485 202.669 299.327 229.05 337.648 230.477",
    stroke: "black",
    strokeWidth: 2
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M502.145 328.299C501.207 346.368 510.172 352.776 519.201 373.041L502.145 328.299Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M502.145 328.299C501.207 346.368 510.172 352.776 519.201 373.041",
    stroke: "black",
    strokeWidth: 2
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M515.688 261.186C509.933 251.936 501.105 246.188 489.507 243.028L515.688 261.186Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M515.688 261.186C509.933 251.936 501.105 246.188 489.507 243.028",
    stroke: "black",
    strokeWidth: 2
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M524.367 250.251H514.258V438.649H524.367V250.251Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M524.367 250.251H514.258V438.649H524.367V250.251Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M525.873 432.027H512.754V441.658H525.873V432.027Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M525.873 432.027H512.754V441.658H525.873V432.027Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M518.198 383.574H508.718V400.578H518.198V383.574Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M518.198 383.574H508.718V400.578H518.198V383.574Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M526.022 381.768H512.329V402.082H526.022V381.768Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M526.022 381.768H512.329V402.082H526.022V381.768Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M528.229 244.934H510.623V253.912H528.229V244.934Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M528.229 244.934H510.623V253.912H528.229V244.934Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M552.908 260.684H485.695V329.302H552.908V260.684Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M552.908 260.684H485.695V329.302H552.908V260.684Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M549.296 263.493H488.903V326.292H549.296V263.493Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M549.296 263.493H488.903V326.292H549.296V263.493Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 251.946H533.758V259.972H550.411V251.946Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 251.946H533.758V259.972H550.411V251.946Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M547 122.596H537.169V251.946H547V122.596Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M547 122.596H537.169V251.946H547V122.596Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 110.483H533.758V122.596H550.411V110.483Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M550.411 110.483H533.758V122.596H550.411V110.483Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M550.164 116.126H589.431",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M550.164 116.126H589.431",
    stroke: "black",
    strokeWidth: 2
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M553.775 92.6763V137.92",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M553.775 92.6763V137.92",
    stroke: "black",
    strokeWidth: 2
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M560.672 97.6172V134.872",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M560.672 97.6172V134.872",
    stroke: "black",
    strokeWidth: 2
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M567.142 100.852V130.422",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M567.142 100.852V130.422",
    stroke: "black",
    strokeWidth: 2
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M572.56 106.57V126.509",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M572.56 106.57V126.509",
    stroke: "black",
    strokeWidth: 2
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M579.03 110.483V121.956",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M579.03 110.483V121.956",
    stroke: "black",
    strokeWidth: 2
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M585.501 112.364V119.891",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M585.501 112.364V119.891",
    stroke: "black",
    strokeWidth: 2
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M420.881 382.899H398.911V401.8H420.881V382.899Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M420.881 382.899H398.911V401.8H420.881V382.899Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M422.385 381.195H408.341V403.507H422.385V381.195Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M422.385 381.195H408.341V403.507H422.385V381.195Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 380.491H413.859V404.309H422.386V380.491Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 380.491H413.859V404.309H422.386V380.491Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 378.887H415.465V405.713H422.386V378.887Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M422.386 378.887H415.465V405.713H422.386V378.887Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 410.155C276.453 410.155 284.268 402.34 284.268 392.7C284.268 383.06 276.453 375.245 266.813 375.245C257.173 375.245 249.358 383.06 249.358 392.7C249.358 402.34 257.173 410.155 266.813 410.155Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 410.155C276.453 410.155 284.268 402.34 284.268 392.7C284.268 383.06 276.453 375.245 266.813 375.245C257.173 375.245 249.358 383.06 249.358 392.7C249.358 402.34 257.173 410.155 266.813 410.155Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 401.879C271.384 401.879 275.089 398.174 275.089 393.603C275.089 389.032 271.384 385.327 266.813 385.327C262.242 385.327 258.537 389.032 258.537 393.603C258.537 398.174 262.242 401.879 266.813 401.879Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M266.813 401.879C271.384 401.879 275.089 398.174 275.089 393.603C275.089 389.032 271.384 385.327 266.813 385.327C262.242 385.327 258.537 389.032 258.537 393.603C258.537 398.174 262.242 401.879 266.813 401.879Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M270.574 384.574C272.319 384.574 273.734 383.159 273.734 381.414C273.734 379.669 272.319 378.254 270.574 378.254C268.829 378.254 267.414 379.669 267.414 381.414C267.414 383.159 268.829 384.574 270.574 384.574Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M270.574 384.574C272.319 384.574 273.734 383.159 273.734 381.414C273.734 379.669 272.319 378.254 270.574 378.254C268.829 378.254 267.414 379.669 267.414 381.414C267.414 383.159 268.829 384.574 270.574 384.574Z",
    fill: "white",
    stroke: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 389.389C278.489 389.389 279.904 387.975 279.904 386.229C279.904 384.484 278.489 383.069 276.744 383.069C274.999 383.069 273.584 384.484 273.584 386.229C273.584 387.975 274.999 389.389 276.744 389.389Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 389.389C278.489 389.389 279.904 387.975 279.904 386.229C279.904 384.484 278.489 383.069 276.744 383.069C274.999 383.069 273.584 384.484 273.584 386.229C273.584 387.975 274.999 389.389 276.744 389.389Z",
    fill: "white",
    stroke: "black"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M279.152 396.311C280.897 396.311 282.312 394.896 282.312 393.151C282.312 391.406 280.897 389.991 279.152 389.991C277.407 389.991 275.992 391.406 275.992 393.151C275.992 394.896 277.407 396.311 279.152 396.311Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M279.152 396.311C280.897 396.311 282.312 394.896 282.312 393.151C282.312 391.406 280.897 389.991 279.152 389.991C277.407 389.991 275.992 391.406 275.992 393.151C275.992 394.896 277.407 396.311 279.152 396.311Z",
    fill: "white",
    stroke: "black"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 403.233C278.489 403.233 279.904 401.818 279.904 400.073C279.904 398.328 278.489 396.913 276.744 396.913C274.999 396.913 273.584 398.328 273.584 400.073C273.584 401.818 274.999 403.233 276.744 403.233Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M276.744 403.233C278.489 403.233 279.904 401.818 279.904 400.073C279.904 398.328 278.489 396.913 276.744 396.913C274.999 396.913 273.584 398.328 273.584 400.073C273.584 401.818 274.999 403.233 276.744 403.233Z",
    fill: "white",
    stroke: "black"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M270.875 407.898C272.62 407.898 274.035 406.483 274.035 404.738C274.035 402.993 272.62 401.578 270.875 401.578C269.13 401.578 267.715 402.993 267.715 404.738C267.715 406.483 269.13 407.898 270.875 407.898Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M270.875 407.898C272.62 407.898 274.035 406.483 274.035 404.738C274.035 402.993 272.62 401.578 270.875 401.578C269.13 401.578 267.715 402.993 267.715 404.738C267.715 406.483 269.13 407.898 270.875 407.898Z",
    fill: "white",
    stroke: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 407.898C264.645 407.898 266.06 406.483 266.06 404.738C266.06 402.993 264.645 401.578 262.9 401.578C261.155 401.578 259.74 402.993 259.74 404.738C259.74 406.483 261.155 407.898 262.9 407.898Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 407.898C264.645 407.898 266.06 406.483 266.06 404.738C266.06 402.993 264.645 401.578 262.9 401.578C261.155 401.578 259.74 402.993 259.74 404.738C259.74 406.483 261.155 407.898 262.9 407.898Z",
    fill: "white",
    stroke: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M256.881 403.534C258.626 403.534 260.041 402.119 260.041 400.374C260.041 398.629 258.626 397.214 256.881 397.214C255.136 397.214 253.721 398.629 253.721 400.374C253.721 402.119 255.136 403.534 256.881 403.534Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M256.881 403.534C258.626 403.534 260.041 402.119 260.041 400.374C260.041 398.629 258.626 397.214 256.881 397.214C255.136 397.214 253.721 398.629 253.721 400.374C253.721 402.119 255.136 403.534 256.881 403.534Z",
    fill: "white",
    stroke: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M254.323 396.462C256.068 396.462 257.483 395.047 257.483 393.302C257.483 391.557 256.068 390.142 254.323 390.142C252.578 390.142 251.163 391.557 251.163 393.302C251.163 395.047 252.578 396.462 254.323 396.462Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M254.323 396.462C256.068 396.462 257.483 395.047 257.483 393.302C257.483 391.557 256.068 390.142 254.323 390.142C252.578 390.142 251.163 391.557 251.163 393.302C251.163 395.047 252.578 396.462 254.323 396.462Z",
    fill: "white",
    stroke: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M256.58 389.239C258.325 389.239 259.74 387.824 259.74 386.079C259.74 384.334 258.325 382.919 256.58 382.919C254.835 382.919 253.42 384.334 253.42 386.079C253.42 387.824 254.835 389.239 256.58 389.239Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M256.58 389.239C258.325 389.239 259.74 387.824 259.74 386.079C259.74 384.334 258.325 382.919 256.58 382.919C254.835 382.919 253.42 384.334 253.42 386.079C253.42 387.824 254.835 389.239 256.58 389.239Z",
    fill: "white",
    stroke: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 384.574C264.645 384.574 266.06 383.159 266.06 381.414C266.06 379.669 264.645 378.254 262.9 378.254C261.155 378.254 259.74 379.669 259.74 381.414C259.74 383.159 261.155 384.574 262.9 384.574Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M262.9 384.574C264.645 384.574 266.06 383.159 266.06 381.414C266.06 379.669 264.645 378.254 262.9 378.254C261.155 378.254 259.74 379.669 259.74 381.414C259.74 383.159 261.155 384.574 262.9 384.574Z",
    fill: "white",
    stroke: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M266.776 418.383C281.181 418.383 292.859 406.706 292.859 392.3C292.859 377.895 281.181 366.217 266.776 366.217C252.371 366.217 240.693 377.895 240.693 392.3C240.693 406.706 252.371 418.383 266.776 418.383Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M262.068 366.444L267.299 394.253",
    stroke: "black",
    strokeWidth: 6
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M266.988 392.651L247.848 407.944",
    stroke: "black",
    strokeWidth: 6
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M266.72 392.899L291.568 403.37",
    stroke: "black",
    strokeWidth: 6
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M369.629 382.082H335.32V400.984H369.629V382.082Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M369.629 382.082H335.32V400.984H369.629V382.082Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M344.714 374.687V383.414L353.04 386.8L361.342 383.339V374.699L344.714 374.687Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M344.714 374.687V383.414L353.04 386.8L361.342 383.339V374.699L344.714 374.687Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M711.486 228.696H701.254V233.01H711.486V228.696Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M711.486 228.696H701.254V233.01H711.486V228.696Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M728.137 228.696H717.905V233.01H728.137V228.696Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M728.137 228.696H717.905V233.01H728.137V228.696Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M709.682 220.968H702.86V229.901H709.682V220.968Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M709.682 220.968H702.86V229.901H709.682V220.968Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M726.532 220.968H719.71V229.696H726.532V220.968Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M726.532 220.968H719.71V229.696H726.532V220.968Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M729.742 216.959H699.448V222.577H729.742V216.959Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M729.742 216.959H699.448V222.577H729.742V216.959Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M728.136 202.514H701.254V217.959H728.136V202.514Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M728.136 202.514H701.254V217.959H728.136V202.514Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M715.199 202.514C726.003 202.514 734.761 193.756 734.761 182.952C734.761 172.148 726.003 163.39 715.199 163.39C704.395 163.39 695.637 172.148 695.637 182.952C695.637 193.756 704.395 202.514 715.199 202.514Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M715.199 202.514C726.003 202.514 734.761 193.756 734.761 182.952C734.761 172.148 726.003 163.39 715.199 163.39C704.395 163.39 695.637 172.148 695.637 182.952C695.637 193.756 704.395 202.514 715.199 202.514Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M715.148 165.143C725.01 165.143 733.004 173.138 733.004 183C733.004 192.862 725.009 200.857 715.148 200.857C705.286 200.857 697.291 192.862 697.291 183C697.291 173.138 705.286 165.143 715.148 165.143Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M715.148 165.143C725.01 165.143 733.004 173.138 733.004 183C733.004 192.862 725.009 200.857 715.148 200.857C705.286 200.857 697.291 192.862 697.291 183C697.291 173.138 705.286 165.143 715.148 165.143Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M728.739 176.633H701.856V189.474H728.739V176.633Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M728.739 176.633H701.856V189.474H728.739V176.633Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 407.667C140.12 407.667 147.935 399.852 147.935 390.212C147.935 380.572 140.12 372.757 130.48 372.757C120.84 372.757 113.025 380.572 113.025 390.212C113.025 399.852 120.84 407.667 130.48 407.667Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 407.667C140.12 407.667 147.935 399.852 147.935 390.212C147.935 380.572 140.12 372.757 130.48 372.757C120.84 372.757 113.025 380.572 113.025 390.212C113.025 399.852 120.84 407.667 130.48 407.667Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 399.391C135.051 399.391 138.756 395.686 138.756 391.115C138.756 386.544 135.051 382.839 130.48 382.839C125.909 382.839 122.204 386.544 122.204 391.115C122.204 395.686 125.909 399.391 130.48 399.391Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M130.48 399.391C135.051 399.391 138.756 395.686 138.756 391.115C138.756 386.544 135.051 382.839 130.48 382.839C125.909 382.839 122.204 386.544 122.204 391.115C122.204 395.686 125.909 399.391 130.48 399.391Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M134.242 382.086C135.987 382.086 137.402 380.671 137.402 378.926C137.402 377.181 135.987 375.766 134.242 375.766C132.497 375.766 131.082 377.181 131.082 378.926C131.082 380.671 132.497 382.086 134.242 382.086Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M134.242 382.086C135.987 382.086 137.402 380.671 137.402 378.926C137.402 377.181 135.987 375.766 134.242 375.766C132.497 375.766 131.082 377.181 131.082 378.926C131.082 380.671 132.497 382.086 134.242 382.086Z",
    fill: "white",
    stroke: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 386.901C142.156 386.901 143.571 385.486 143.571 383.741C143.571 381.996 142.156 380.581 140.411 380.581C138.666 380.581 137.251 381.996 137.251 383.741C137.251 385.486 138.666 386.901 140.411 386.901Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 386.901C142.156 386.901 143.571 385.486 143.571 383.741C143.571 381.996 142.156 380.581 140.411 380.581C138.666 380.581 137.251 381.996 137.251 383.741C137.251 385.486 138.666 386.901 140.411 386.901Z",
    fill: "white",
    stroke: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M142.819 393.823C144.564 393.823 145.979 392.408 145.979 390.663C145.979 388.918 144.564 387.503 142.819 387.503C141.074 387.503 139.659 388.918 139.659 390.663C139.659 392.408 141.074 393.823 142.819 393.823Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M142.819 393.823C144.564 393.823 145.979 392.408 145.979 390.663C145.979 388.918 144.564 387.503 142.819 387.503C141.074 387.503 139.659 388.918 139.659 390.663C139.659 392.408 141.074 393.823 142.819 393.823Z",
    fill: "white",
    stroke: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 400.745C142.156 400.745 143.571 399.33 143.571 397.585C143.571 395.84 142.156 394.425 140.411 394.425C138.666 394.425 137.251 395.84 137.251 397.585C137.251 399.33 138.666 400.745 140.411 400.745Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M140.411 400.745C142.156 400.745 143.571 399.33 143.571 397.585C143.571 395.84 142.156 394.425 140.411 394.425C138.666 394.425 137.251 395.84 137.251 397.585C137.251 399.33 138.666 400.745 140.411 400.745Z",
    fill: "white",
    stroke: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M134.543 405.41C136.288 405.41 137.703 403.995 137.703 402.25C137.703 400.505 136.288 399.09 134.543 399.09C132.798 399.09 131.383 400.505 131.383 402.25C131.383 403.995 132.798 405.41 134.543 405.41Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M134.543 405.41C136.288 405.41 137.703 403.995 137.703 402.25C137.703 400.505 136.288 399.09 134.543 399.09C132.798 399.09 131.383 400.505 131.383 402.25C131.383 403.995 132.798 405.41 134.543 405.41Z",
    fill: "white",
    stroke: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 405.41C128.312 405.41 129.727 403.995 129.727 402.25C129.727 400.505 128.312 399.09 126.567 399.09C124.822 399.09 123.407 400.505 123.407 402.25C123.407 403.995 124.822 405.41 126.567 405.41Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 405.41C128.312 405.41 129.727 403.995 129.727 402.25C129.727 400.505 128.312 399.09 126.567 399.09C124.822 399.09 123.407 400.505 123.407 402.25C123.407 403.995 124.822 405.41 126.567 405.41Z",
    fill: "white",
    stroke: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M120.548 401.046C122.293 401.046 123.708 399.631 123.708 397.886C123.708 396.141 122.293 394.726 120.548 394.726C118.803 394.726 117.388 396.141 117.388 397.886C117.388 399.631 118.803 401.046 120.548 401.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M120.548 401.046C122.293 401.046 123.708 399.631 123.708 397.886C123.708 396.141 122.293 394.726 120.548 394.726C118.803 394.726 117.388 396.141 117.388 397.886C117.388 399.631 118.803 401.046 120.548 401.046Z",
    fill: "white",
    stroke: "black"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M117.99 393.974C119.735 393.974 121.15 392.56 121.15 390.814C121.15 389.069 119.735 387.654 117.99 387.654C116.245 387.654 114.83 389.069 114.83 390.814C114.83 392.56 116.245 393.974 117.99 393.974Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M117.99 393.974C119.735 393.974 121.15 392.56 121.15 390.814C121.15 389.069 119.735 387.654 117.99 387.654C116.245 387.654 114.83 389.069 114.83 390.814C114.83 392.56 116.245 393.974 117.99 393.974Z",
    fill: "white",
    stroke: "black"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M120.247 386.751C121.992 386.751 123.407 385.336 123.407 383.591C123.407 381.846 121.992 380.431 120.247 380.431C118.502 380.431 117.087 381.846 117.087 383.591C117.087 385.336 118.502 386.751 120.247 386.751Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M120.247 386.751C121.992 386.751 123.407 385.336 123.407 383.591C123.407 381.846 121.992 380.431 120.247 380.431C118.502 380.431 117.087 381.846 117.087 383.591C117.087 385.336 118.502 386.751 120.247 386.751Z",
    fill: "white",
    stroke: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 382.086C128.312 382.086 129.727 380.671 129.727 378.926C129.727 377.181 128.312 375.766 126.567 375.766C124.822 375.766 123.407 377.181 123.407 378.926C123.407 380.671 124.822 382.086 126.567 382.086Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M126.567 382.086C128.312 382.086 129.727 380.671 129.727 378.926C129.727 377.181 128.312 375.766 126.567 375.766C124.822 375.766 123.407 377.181 123.407 378.926C123.407 380.671 124.822 382.086 126.567 382.086Z",
    fill: "white",
    stroke: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M130.442 415.895C144.847 415.895 156.525 404.217 156.525 389.812C156.525 375.407 144.847 363.729 130.442 363.729C116.037 363.729 104.359 375.407 104.359 389.812C104.359 404.217 116.037 415.895 130.442 415.895Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 6
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M125.772 362.636L130.672 391.794",
    stroke: "black",
    strokeWidth: 6
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M131.086 390.167L111.514 408.031",
    stroke: "black",
    strokeWidth: 6
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M130.842 390.426L153.059 401.294",
    stroke: "black",
    strokeWidth: 6
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M354.595 333.204H351.585V359.742H354.595V333.204Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M354.595 333.204H351.585V359.742H354.595V333.204Z",
    fill: "white",
    stroke: "black"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 354.873H354.595",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 354.873H354.595",
    stroke: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 347.278H354.595",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 347.278H354.595",
    stroke: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 339.624H354.595",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 339.624H354.595",
    stroke: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 337.497H354.595",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 337.497H354.595",
    stroke: "black"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M354.446 327.185C354.446 330.177 353.839 332.602 353.09 332.602C352.341 332.602 351.734 330.177 351.734 327.185C351.734 324.193 352.341 321.768 353.09 321.768C353.839 321.768 354.446 324.193 354.446 327.185Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M354.446 327.185C354.446 330.177 353.839 332.602 353.09 332.602C352.341 332.602 351.734 330.177 351.734 327.185C351.734 324.193 352.341 321.768 353.09 321.768C353.839 321.768 354.446 324.193 354.446 327.185Z",
    fill: "white",
    stroke: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 341.459H346.315V340.227C346.315 340.227 342.021 338.703 341.099 339.625C340.283 340.441 339.946 344.187 341.099 344.243C343.707 344.369 351.586 344.369 351.586 344.369",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 341.459H346.315V340.227C346.315 340.227 342.021 338.703 341.099 339.625C340.283 340.441 339.946 344.187 341.099 344.243C343.707 344.369 351.586 344.369 351.586 344.369",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 341.459H346.315V340.227C346.315 340.227 342.021 338.703 341.099 339.625C340.283 340.441 339.946 344.187 341.099 344.243C343.707 344.369 351.586 344.369 351.586 344.369",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M351.585 341.459H346.315V340.227C346.315 340.227 342.021 338.703 341.099 339.625C340.283 340.441 339.946 344.187 341.099 344.243C343.707 344.369 351.586 344.369 351.586 344.369",
    stroke: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M348.536 341.459V344.368",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M348.536 341.459V344.368",
    stroke: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M353.09 321.768C351.585 320.963 358.908 326.044 358.908 333.407C358.908 337.002 354.594 345.252 354.595 347.278",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M353.09 321.768C351.585 320.963 358.908 326.044 358.908 333.407C358.908 337.002 354.594 345.252 354.595 347.278",
    stroke: "black"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M303.544 227.828H278.526V246.73H303.544V227.828Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M303.544 227.828H278.526V246.73H303.544V227.828Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M282.727 220.567V229.295L291.053 232.681L299.355 229.22V220.579L282.727 220.567Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M282.727 220.567V229.295L291.053 232.681L299.355 229.22V220.579L282.727 220.567Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M284.113 121.603L287.346 121.376L287.93 119.797H294.15L294.944 121.347L297.957 121.603V220.974H284.113V121.603Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M284.113 121.603L287.346 121.376L287.93 119.797H294.15L294.944 121.347L297.957 121.603V220.974H284.113V121.603Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M299.994 190.276H282.087V200.508H299.994V190.276Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M299.994 190.276H282.087V200.508H299.994V190.276Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M302.778 193.587H279.303V197.198H302.778V193.587Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M302.778 193.587H279.303V197.198H302.778V193.587Z",
    fill: "white",
    stroke: "black"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M300.486 138.868H281.584V163.886H300.486V138.868Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M300.486 138.868H281.584V163.886H300.486V138.868Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 159.691H281.974L285.36 151.365L281.899 143.063H273.259L273.247 159.691Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 159.691H281.974L285.36 151.365L281.899 143.063H273.259L273.247 159.691Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M347.168 361.861L349.839 361.832L350.321 360.422H355.459L356.116 361.828L358.605 361.861V374.794H347.168V361.861Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M347.168 361.861L349.839 361.832L350.321 360.422H355.459L356.116 361.828L358.605 361.861V374.794H347.168V361.861Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M292.241 93.6299H289.231V120.168H292.241V93.6299Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M292.241 93.6299H289.231V120.168H292.241V93.6299Z",
    fill: "white",
    stroke: "black"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 115.298H292.241",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 115.298H292.241",
    stroke: "black"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 107.703H292.241",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 107.703H292.241",
    stroke: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 100.05H292.241",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 100.05H292.241",
    stroke: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 97.9219H292.241",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 97.9219H292.241",
    stroke: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M292.092 87.6099C292.092 90.6019 291.485 93.0269 290.736 93.0269C289.987 93.0269 289.38 90.6019 289.38 87.6099C289.38 84.6179 289.987 82.1929 290.736 82.1929C291.485 82.1929 292.092 84.6189 292.092 87.6099Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M292.092 87.6099C292.092 90.6019 291.485 93.0269 290.736 93.0269C289.987 93.0269 289.38 90.6019 289.38 87.6099C289.38 84.6179 289.987 82.1929 290.736 82.1929C291.485 82.1929 292.092 84.6189 292.092 87.6099Z",
    fill: "white",
    stroke: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 101.884H283.961V100.652C283.961 100.652 279.667 99.1282 278.745 100.05C277.929 100.866 277.592 104.613 278.745 104.668C281.353 104.794 289.232 104.794 289.232 104.794",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 101.884H283.961V100.652C283.961 100.652 279.667 99.1282 278.745 100.05C277.929 100.866 277.592 104.613 278.745 104.668C281.353 104.794 289.232 104.794 289.232 104.794",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 101.884H283.961V100.652C283.961 100.652 279.667 99.1282 278.745 100.05C277.929 100.866 277.592 104.613 278.745 104.668C281.353 104.794 289.232 104.794 289.232 104.794",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M289.231 101.884H283.961V100.652C283.961 100.652 279.667 99.1282 278.745 100.05C277.929 100.866 277.592 104.613 278.745 104.668C281.353 104.794 289.232 104.794 289.232 104.794",
    stroke: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M286.182 101.884V104.794",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M286.182 101.884V104.794",
    stroke: "black"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M290.736 82.1931C289.231 81.3881 296.554 86.4691 296.554 93.8321C296.554 97.4271 292.24 105.677 292.241 107.703",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M290.736 82.1931C289.231 81.3881 296.554 86.4691 296.554 93.8321C296.554 97.4271 292.24 105.677 292.241 107.703",
    stroke: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M211.401 120.168H194.848V168.281H211.401V120.168Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M211.401 120.168H194.848V168.281H211.401V120.168Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M210.511 143.603L206.648 150.926L210.51 159.001L218.335 159.151L218.485 143.652L210.511 143.603Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M210.511 143.603L206.648 150.926L210.51 159.001L218.335 159.151L218.485 143.652L210.511 143.603Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 144.51H218.586V158.244H273.247V144.51Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M273.247 144.51H218.586V158.244H273.247V144.51Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M260.644 141.926H232.806V160.827H260.644V141.926Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M260.644 141.926H232.806V160.827H260.644V141.926Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M251.766 140.221H241.834V162.533H251.766V140.221Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M251.766 140.221H241.834V162.533H251.766V140.221Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M259.835 227.827H231.997V246.728H259.835V227.827Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M259.835 227.827H231.997V246.728H259.835V227.827Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M250.958 226.123H241.026V248.435H250.958V226.123Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M250.958 226.123H241.026V248.435H250.958V226.123Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M249.311 137.03H245.098V140.04H249.311V137.03Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M247.928 222.457H243.715V225.467H247.928V222.457Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M194.848 130.422H210.761",
    stroke: "black",
    strokeWidth: 4
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M199.024 78.2681H208.052",
    stroke: "black",
    strokeWidth: 4
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M386.532 228.551H352.725V245.104H386.532V228.551Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M386.532 228.551H352.725V245.104H386.532V228.551Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 228.178L369.016 232.041L379.958 228.179L380.162 212.421H359.095V228.178Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 228.178L369.016 232.041L379.958 228.179L380.162 212.421H359.095V228.178Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 217.838H380.092",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M359.095 217.838H380.092",
    stroke: "black",
    strokeWidth: 3
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M359.662 212.969C359.662 212.969 352.449 205.127 352.439 191.754C352.426 174.801 359.662 168.28 359.662 168.28H380.729C380.729 168.28 387.35 176.131 387.35 191.754C387.35 206.1 380.729 212.969 380.729 212.969H359.662Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M359.662 212.969C359.662 212.969 352.449 205.127 352.439 191.754C352.426 174.801 359.662 168.28 359.662 168.28H380.729C380.729 168.28 387.35 176.131 387.35 191.754C387.35 206.1 380.729 212.969 380.729 212.969H359.662Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M380.624 130.54H359.557V168.399H380.624V130.54Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M380.624 130.54H359.557V168.399H380.624V130.54Z",
    fill: "white",
    stroke: "black"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M331.255 145.477C331.255 145.477 349.203 135.734 371.495 135.734C392.72 135.734 407.982 145.477 407.982 145.477L407.767 147.641L381.109 151.912L369.139 152.199L359.331 151.817L331.203 147.568L331.255 145.477Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M331.255 145.477C331.255 145.477 349.203 135.734 371.495 135.734C392.72 135.734 407.982 145.477 407.982 145.477L407.767 147.641L381.109 151.912L369.139 152.199L359.331 151.817L331.203 147.568L331.255 145.477Z",
    fill: "white",
    stroke: "black"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M362.421 206.595C362.421 206.595 357.563 200.821 357.555 190.974C357.545 178.491 362.421 173.69 362.421 173.69H377.596C377.596 173.69 382.028 179.471 382.028 190.974C382.028 201.537 377.596 206.595 377.596 206.595H362.421Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M362.421 206.595C362.421 206.595 357.563 200.821 357.555 190.974C357.545 178.491 362.421 173.69 362.421 173.69H377.596C377.596 173.69 382.028 179.471 382.028 190.974C382.028 201.537 377.596 206.595 377.596 206.595H362.421Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M373.735 173.69H366.445V174.894H373.735V173.69Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M407.986 145.858H331.705V147.664H407.986V145.858Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M407.986 145.858H331.705V147.664H407.986V145.858Z",
    fill: "white",
    stroke: "black"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M334.382 144.046H331.705V145.852H334.382V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M378.321 144.046H375.644V145.852H378.321V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M370.738 144.046H368.062V145.852H370.738V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M363.155 144.046H360.478V145.852H363.155V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M356.606 144.046H353.929V145.852H356.606V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M350.217 144.046H347.541V145.852H350.217V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M343.526 144.046H340.85V145.852H343.526V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M404.416 144.046H401.74V145.852H404.416V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M392.819 144.046H390.142V145.852H392.819V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M386.351 144.046H383.674V145.852H386.351V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M398.984 144.046H396.307V145.852H398.984V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M408.432 144.046H405.755V145.852H408.432V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M338.174 144.046H335.497V145.852H338.174V144.046Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M374.003 128.917H366.178V130.121H374.003V128.917Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M374.003 128.917H366.178V130.121H374.003V128.917Z",
    fill: "white",
    stroke: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M374.29 197.499H367V200.509H374.29V197.499Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M367.081 198.101H365.275V199.907H367.081V198.101Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M369.894 173.69V199.004",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M369.894 173.69V199.004",
    stroke: "black",
    strokeWidth: 2
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 469.014V516.967",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M185.405 469.014V516.967",
    stroke: "black",
    strokeWidth: 2
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M177.876 564.838L177.711 667.945L227.09 668.024L227.255 564.917L177.876 564.838Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M195.111 521.571V660.327H210.915L210.761 519.274",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M195.111 521.571V660.327H210.915L210.761 519.274",
    stroke: "black",
    strokeWidth: 2
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 602.202H197.519V615.444H208.353V602.202Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 602.202H197.519V615.444H208.353V602.202Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 617.793H197.596V631.035H208.43V617.793Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 617.793H197.596V631.035H208.43V617.793Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 597.846H197.519V600.599H208.353V597.846Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 597.846H197.519V600.599H208.353V597.846Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M207.274 585.904H198.747V597.671H207.274V585.904Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M207.274 585.904H198.747V597.671H207.274V585.904Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 584.529H197.519V585.905H208.353V584.529Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M208.353 584.529H197.519V585.905H208.353V584.529Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M207.752 596.47H198.121V597.674H207.752V596.47Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M207.752 596.47H198.121V597.674H207.752V596.47Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 633.143H197.596V637.371H208.43V633.143Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M208.43 633.143H197.596V637.371H208.43V633.143Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M197.596 643.326V639.098H208.43V643.326L205.669 644.53H203.562L202.057 645.733L200.251 643.928L197.596 643.326Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M197.596 643.326V639.098H208.43V643.326L205.669 644.53H203.562L202.057 645.733L200.251 643.928L197.596 643.326Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 645.733L197.596 648.234L207.274 650.612L197.596 652.719L207.274 654.524L198.121 656.715",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 645.733L197.596 648.234L207.274 650.612L197.596 652.719L207.274 654.524L198.121 656.715",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 645.733L197.596 648.234L207.274 650.612L197.596 652.719L207.274 654.524L198.121 656.715",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M202.057 645.733L197.596 648.234L207.274 650.612L197.596 652.719L207.274 654.524L198.121 656.715",
    stroke: "black"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M207.277 657.301H198.75V660.275H207.277V657.301Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M207.277 657.301H198.75V660.275H207.277V657.301Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M207.829 656.699H198.198V657.903H207.829V656.699Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M207.829 656.699H198.198V657.903H207.829V656.699Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlungerLift);
export default __webpack_public_path__ + "static/media/plunger-lift.d4ea68c29bf5d958c42875cd6eeb6a77.svg";
export { ForwardRef as ReactComponent };